import React from "react";
import { Button, Card, Col, Empty, Row, Spin, Typography } from "antd";

const { Text, Paragraph } = Typography;

interface ProcessItem {
    index: number;
    ambito: string;
    codigo_externo: string;
    forma_iniciar: string;
    nome: string;
    nome_externo: string;
}

interface ProcessCardsProps {
    processList: ProcessItem[];
    isLoadingData: boolean;
    startingProcessIndex: number | null;
    onProcessStart: (process: ProcessItem) => void;
}

export function ProcessCards({ processList, isLoadingData, startingProcessIndex, onProcessStart }: ProcessCardsProps) {
    function handleProcessStart(process: ProcessItem) {
        onProcessStart(process);
    }

    const isEmptyList = processList.length === 0;

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24}>
                <Spin spinning={isLoadingData}>
                    {isEmptyList ? (
                        <Empty />
                    ) : (
                        <Row gutter={[16, 16]} type="flex">
                            {processList.map((process) => {
                                const isDisabled =
                                    startingProcessIndex !== null && startingProcessIndex !== process.index;

                                return (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={6} key={process.index}>
                                        <Card
                                            title={process.codigo_externo}
                                            hoverable
                                            size="small"
                                            style={{ height: "100%", display: "flex", flexDirection: "column" }}
                                            bodyStyle={{
                                                flexGrow: 1,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <div>
                                                    <Text
                                                        type="secondary"
                                                        style={{
                                                            fontSize: "12px",
                                                            display: "block",
                                                            color: "rgba(0, 0, 0, 0.45)",
                                                        }}
                                                    >
                                                        Nome
                                                    </Text>
                                                    <Paragraph
                                                        style={{ fontWeight: "bold", textAlign: "justify" }}
                                                        ellipsis={{ rows: 1, expandable: true }}
                                                    >
                                                        {process.nome_externo}
                                                    </Paragraph>

                                                    <Text
                                                        type="secondary"
                                                        style={{
                                                            fontSize: "12px",
                                                            display: "block",
                                                            color: "rgba(0, 0, 0, 0.45)",
                                                        }}
                                                    >
                                                        Âmbito
                                                    </Text>
                                                    <Paragraph ellipsis={{ rows: 1, expandable: true }}>
                                                        {process.ambito}
                                                    </Paragraph>
                                                </div>

                                                <Button
                                                    type="primary"
                                                    block
                                                    disabled={isDisabled}
                                                    loading={startingProcessIndex === process.index}
                                                    onClick={() => handleProcessStart(process)}
                                                >
                                                    Iniciar
                                                </Button>
                                            </div>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    )}
                </Spin>
            </Col>
        </Row>
    );
}
